export default __webpack_public_path__ + "static/media/avatar.c4709fd0.png";